import { FlightWatchState } from './reducers';
export const getFlightWatch = ({ pages: { flightWatch } }) => flightWatch as FlightWatchState;
